import React, {Component} from "react"

import {H2} from "@irati/ui/src/Headings"
import {Para} from "@irati/ui/src/Labels"
import Form from "@irati/ui/src/Form"
import Loading from "@irati/ui/src/Loading"
import {ValidationButton} from "@irati/ui/src/FormItem"
import {Password} from "@irati-web/fields/user"
import {FormattedMessage, InjectIntl, injectIntl} from "@irati/utils/lang"
import SetPasswordError from "@irati/ui/src/SetPasswordError"
import tracking from "@irati-tracking/platform"
import {User} from "@irati/types"

export type HandleSetPassword = (password: string) => Promise<any>

interface Props extends InjectIntl {
  user: User,
  onComplete: HandleSetPassword
}

interface State {
  password: string | null,
  confirmPassword: string | null,
  saving?: Promise<void>
}

class UserOnboardingSetPassword extends Component<Props> {
  state: State = {
    password: null,
    confirmPassword: null
  }

  componentDidMount = () => {
    tracking.onBoarding("Step 2")
  }

  handleChange = (label: string, value: any) => {
    this.setState({
      [label]: value,
      saving: null
    })
  }

  handleSubmit = () => {
    const {password} = this.state

    const saving = this.props.onComplete(password!)

    this.setState({saving})
  }

  render() {
    const {formatMessage, header} = this.props
    const {password, confirmPassword, saving} = this.state

    return (
      <div>
        <H2 tiny>{header}</H2>
        <Para>
          <FormattedMessage id="onboarding.setPassword.data.header2" />
        </Para>
        <Form>
          <Password
            label="onboarding.setPassword.password.fields.label"
            onChange={(value) => this.handleChange("password", value)}
            placeholder="onboarding.setPassword.password.fields.placeholder"
            value={password}
            hint={formatMessage({id: "platform.password.hint"})} />
          <Password
            label="onboarding.setPassword.confirmPassword.fields.label"
            placeholder="onboarding.setPassword.confirmPassword.fields.placeholder"
            name="confirmPassword"
            onChange={(value) => this.handleChange("confirmPassword", value)}
            value={confirmPassword}
            passwordToMatch={this.state.password} />
          <Loading load={saving} useLoader={false} />
          <Loading load={saving} useLoader={false} Error={SetPasswordError} />
          <div className="text-center push--top">
            <ValidationButton
              primary
              large
              load={saving}
              loading={formatMessage({id: "onboarding.setPassword.button.saving"})}
              onClick={this.handleSubmit}>
              <FormattedMessage id="onboarding.setPassword.button.continue" />
            </ValidationButton>
          </div>
        </Form>
      </div>
    )
  }
}

export default injectIntl(UserOnboardingSetPassword)
